<template>
  <div style="background: white;padding:20px;margin-bottom:20px;">
    <el-row :gutter="20" style="margin-bottom: 0;">
      <el-col :span="24">
        <div>商机数量趋势</div>
      </el-col>
    </el-row>
    <el-row v-if="cardData.time" :gutter="20" style="height:130px;">
      <el-col :span="4" style="font-size: 14px;display: flex;height:100%;flex-direction: column;justify-content: space-between;">
        <div class="t-lgray" style="font-size:12px;">{{cardData.time}} 更新</div>
        <div>
          <div class="t-gray pd-b-5" style="margin-top: auto">本周数量 <span class="t-black" style="margin-left:10px;">{{cardData.this_week_clue_count}}</span></div>
          <div class="t-gray pd-b-5">本周最多 <span class="t-black" style="margin-left:10px;">{{cardData.this_week_max_clue}}</span></div>
        </div>


      </el-col>
      <el-col :span="20" style="font-size: 14px;">
        <div v-loading="loading" style="height:130px;width: 100%;" ref="barchart"></div>
      </el-col>

    </el-row>
    <el-empty v-else style="height: 129px" :image-size="80" description="暂无数据"></el-empty>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getClueTrend, getThisMonthClue} from "@/api/api";

export default {
  name: "ClueTendcyCard",
  props:['refreshCount','resizeChartCount'],
  data(){
    return {
      loading:false,
      cardData: {
        time: "",
        this_week_clue_count: 99,
        this_week_max_clue: 24,
        data: {
          key: [],
          value: []
        }
      }
    }
  },
  async mounted() {
    await this.refresh(true)
  },
  watch: {
    resizeChartCount(){
      if(this.chartHandle){
        this.chartHandle.resize()
      }
    },
    refreshCount() {
      this.refresh()
    },
  },
  methods:{
    updateChart(){
      let that = this
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(this.$refs.barchart);
      // console.log('myChart',myChart)
// 绘制图表
      myChart.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor:"#fdfae5",
          borderColor:"#fdfae5",
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          },
          //
          formatter(params) {
            const index = params[0].dataIndex
            return `<div ><div style="font-weight: bold;">商机数量 ${that.cardData.data.value[index]}</div><div style="color:lightgray">${that.cardData.data.key[index]}</div></div>`
            // console.log(this)
          }
        },
        grid:{
          top:'1px',
          left:'0px',
          right:'0px',
          bottom:'1px',
          width:"100%",
          containLabel: true
        },
        xAxis: {
          axisLine:{
            show:true,
            lineStyle:{
              color:"lightgray"
            }
          },
          axisLabel:{
            show:false
          },
          axisTick:{
            show:false,
          },
          data: this.cardData.data.key
        },
        yAxis: {
          axisLabel: {
            show:false
          },
          axisLine:{
            show:false
          },
          splitLine:{
            show:true
          }
        },
        series: [
          {
            name: '商机数量',
            type: 'bar',
            data: this.cardData.data.value,
            itemStyle:{
              color:"#409EFF",
              borderColor:"#409EFF",
              borderWidth:1
            }

          }
        ]
      });
      myChart.resize();
      this.chartHandle = myChart
      window.onresize = function (){
        myChart.resize()
      }
    },
    async getData(){

      let postData = {
      }
      let res = await getClueTrend(postData)
      let resData = res.respData
      Object.assign(this.cardData,resData)
      this.updateChart()

      this.loading = false
      // console.log('getClueTrend',resData,this.cardData)

    },

    async refresh(loading=true){
      this.loading = loading
      await this.getData()
    }
  }
}
</script>

<style scoped>

</style>
